// Typelizer digest ce444ce01378574beb9bf9fc47122ea7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/relief/listings/:listing_id/requests */
  index: (
    params: { teacherId: string | number; listingId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/listings/:listing_id/requests', params, options),
    method: 'get',
  }),
}
